import WatchLayout from './watch-layout';

export default WatchLayout;